import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e25ef21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-left" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "p-grid p-col-12"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-d-flex p-justify-center main-img" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "p-col-12 p-d-flex p-justify-center" }, "Enter video URLs", -1))
const _hoisted_6 = { class: "p-d-flex p-flex-column p-ai-center p-col-12 p-input-icon-left search-block" }
const _hoisted_7 = { class: "p-m-auto" }
const _hoisted_8 = {
  key: 1,
  class: "p-grid p-col-12 main-details"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"p-col-12 p-d-flex p-justify-between p-flex-wrap\" data-v-0e25ef21><div class=\"p-d-flex box-text\" data-v-0e25ef21><div class=\"box b-black\" data-v-0e25ef21>01</div> Content URL </div><div class=\"p-d-flex box-text\" data-v-0e25ef21><div class=\"box b-red\" data-v-0e25ef21>02</div> Details </div><div class=\"p-d-flex box-text\" data-v-0e25ef21><div class=\"box b-white box-color-dark\" data-v-0e25ef21>03</div> Licensing </div></div><div class=\"gorisontal p-col-12\" data-v-0e25ef21></div>", 2)
const _hoisted_11 = { class: "p-d-flex p-justify-between w-100 p-mt-6 p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBarwithBrowse = _resolveComponent("SearchBarwithBrowse")!
  const _component_VideoUrlInput = _resolveComponent("VideoUrlInput")!
  const _component_SecretTip = _resolveComponent("SecretTip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ContentPiece = _resolveComponent("ContentPiece")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_SearchBarwithBrowse, { class: "browse" }),
    _createElementVNode("h2", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'my-content', params: { creatorID: _ctx.$route.params.creatorID } }))),
      style: {"cursor":"pointer","margin-left":"45px"}
    }, [
      _hoisted_2,
      _createTextVNode(" Content Manager ")
    ]),
    ($setup.steep === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countInputs, (input, index) => {
              return (_openBlock(), _createBlock(_component_VideoUrlInput, {
                onChangeValueUrl: $setup.changeValueUrl,
                input: input,
                key: index
              }, null, 8, ["onChangeValueUrl", "input"]))
            }), 128)),
            _createElementVNode("span", {
              class: "add-url p-mt-4",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.countInputs.push({ value: '', input: $setup.countInputs.length })))
            }, "+ Add Another URL")
          ]),
          _createVNode(_component_SecretTip, {
            class: "p-col-12 p-d-flex p-justify-center",
            text: 'From here you can check out creators, content items, running campaigns or create a new campaign!'
          }),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: "Continue",
              class: "red-button p-col-12",
              loading: $setup.loadingVideoInfo,
              onClick: $setup.verifyUrls
            }, null, 8, ["loading", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.steep === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videosInfo, (item, index) => {
            return (_openBlock(), _createBlock(_component_ContentPiece, {
              item: item,
              number: index,
              onRemovePiece: $setup.removePiece,
              onChangeItemPiece: $setup.changeItemPiece,
              key: `${index}_pieces`,
              class: "p-col-12 p-mt-6"
            }, null, 8, ["item", "number", "onRemovePiece", "onChangeItemPiece"]))
          }), 128)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", {
              class: "p-text-uppercase previous",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.steep -= 1))
            }, "Previous"),
            _createVNode(_component_Button, {
              label: "Continue",
              class: "red-button p-col-12",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.steep += 1))
            }),
            _createVNode(_component_Button, {
              label: "submit",
              class: "red-button p-col-12",
              loading: $setup.uploadingContent,
              onClick: $setup.submitContentItems
            }, null, 8, ["loading", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}